export default __webpack_public_path__ + "static/media/handsome-young-man-working-with-papers.6af9cfdb.jpg";